// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.customer-popup-shell {
  background: linear-gradient(180deg,#0b1220 0%, #0f172a 100%);
  color: #fff;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
.customer-header {
  display:flex;
  justify-content:space-between;
  align-items:center;
  padding:12px 16px;
  border-bottom:1px solid rgba(255,255,255,0.04);
}
.customer-main {
  padding: 12px;
  flex: 1 1 auto;
  overflow: auto;
}
.brand { font-weight:700 }

/* Popup-mode: when opened as a focused small window, render the waiver/store
   centered on a subtle glass card. WaiverForm injects additional page-level
   styles; keep this shell minimal so the result feels like a single dialog. */
.customer-popup-shell.popup-mode {
  background: transparent;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}
.customer-popup-shell.popup-mode .customer-header {
  display: none;
}
.customer-popup-shell.popup-mode .customer-main {
  padding: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/CustomerPopup.css"],"names":[],"mappings":"AAAA;EACE,4DAA4D;EAC5D,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,iBAAiB;EACjB,8CAA8C;AAChD;AACA;EACE,aAAa;EACb,cAAc;EACd,cAAc;AAChB;AACA,SAAS,gBAAgB;;AAEzB;;8EAE8E;AAC9E;EACE,uBAAuB;EACvB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;EACV,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB","sourcesContent":[".customer-popup-shell {\n  background: linear-gradient(180deg,#0b1220 0%, #0f172a 100%);\n  color: #fff;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n.customer-header {\n  display:flex;\n  justify-content:space-between;\n  align-items:center;\n  padding:12px 16px;\n  border-bottom:1px solid rgba(255,255,255,0.04);\n}\n.customer-main {\n  padding: 12px;\n  flex: 1 1 auto;\n  overflow: auto;\n}\n.brand { font-weight:700 }\n\n/* Popup-mode: when opened as a focused small window, render the waiver/store\n   centered on a subtle glass card. WaiverForm injects additional page-level\n   styles; keep this shell minimal so the result feels like a single dialog. */\n.customer-popup-shell.popup-mode {\n  background: transparent;\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n}\n.customer-popup-shell.popup-mode .customer-header {\n  display: none;\n}\n.customer-popup-shell.popup-mode .customer-main {\n  padding: 0;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
